module.exports = function() {
  return new Worker(__webpack_public_path__ + "ec5f891d59ee9ffa8401.worker.js");
};